import React, {useState, useEffect} from 'react';
import 'fontsource-roboto';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

export default function StepTiles(props) {
  const [isLoaded, setIsLoaded] = useState(false);
  const [options, setOptions] = useState([]);
  const ignoredOptionProperties = ['id', 'label', 'nextStep'];

  useEffect(() => {
    if (props.step && !isLoaded) {
      setOptions(props.step.options.filter(filterOptions));
      setIsLoaded(true);
    }
  }, [props]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (props.onChange && options.length === 1)
      props.onChange(options[0]);
  }, [options]); // eslint-disable-line react-hooks/exhaustive-deps

  const filterOptions = option => {
    // verificam daca in props.data exista o proprietate cu numele diferit de id, label sau nextStep si filtram dupa caz
    const keys = Object.keys(option).filter(key => !~ignoredOptionProperties.indexOf(key));
    for (let i = 0; i < keys.length; i++) {
      if (props.data.hasOwnProperty(keys[i]) && option[keys[i]] !== props.data[keys[i]])
        return false;
    }
    return true;
  };

  const handleStepComplete = (option) => () => {
    props.onChange(option);
  };

  if (!isLoaded)
    return null;

  return (
    <Grid container spacing={1} alignItems='stretch'>
      {options.map(option =>
        <Grid key={option.id} item
          xs={props.step.xs ? props.step.xs : 12}
          sm={props.step.sm ? props.step.sm : 6}
          md={props.step.md ? props.step.md : 3}
        >
          <Button variant={option.isDefault ? 'contained' : 'outlined'} fullWidth style={{padding: '16px 2px'}}
            color={Boolean(props.step.nextStep) || Boolean(option.nextStep) ? 'primary': 'secondary'}
            onClick={handleStepComplete(option)}
          >
            {option.label}
          </Button>
        </Grid>
      )}
    </Grid>
  );
}